import { Common } from '@stockbit/ui';

import { FormLabel } from '../styled';

const { Flex } = Common;

interface FormItemProps {
  className?: string;
  label?: string | JSX.Element;
  children?: JSX.Element | JSX.Element[];
}

function FormItem({ className, label, children }: FormItemProps) {
  return (
    <Flex className={className} py="10px" align="center">
      <FormLabel>{label}</FormLabel>
      <div style={{ width: 210 }}>{children}</div>
    </Flex>
  );
}

export default FormItem;
